export default __webpack_public_path__ + "static/measuringandmarkingtools-61f517ee567dcae04606ca0961a57c23.png";